var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.displayValue()))]),(_vm.displayValueEmail())?_c('span',[_vm._v(_vm._s(_vm.displayValueEmail()))]):_vm._e(),(_vm.displayValuePhone())?_c('span',[_vm._v(_vm._s(_vm.displayValuePhone()))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }